






















import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation, Action} from 'vuex-class'
import {InventoryItem, Room} from '@/store/types'
import InventoryRoom from './InventoryRoom.vue'

@Component({
  components: {
    InventoryRoom,
  },
})
export default class InventoryRooms extends Vue {
  @Getter('inventory') public inventory!: InventoryItem[]
  @Getter('rooms') public rooms!: Room[]
  @Getter('totalVolume') public totalVolume!: number
  @Getter('activeRoomId') public activeRoomId!: number
}
